
import React from 'react';

interface StatusChipProps {
    status: string;
    onSelect: (s: string) => void;
}

export const StatusChip: React.FC<StatusChipProps> = ({ status, onSelect }) => {
    const options = ['Activo', 'Eliminado', 'Actualizado'];
    const getColors = (s: string) => {
        if (s === 'Activo') return 'bg-green-100 text-green-800 border-green-200';
        if (s === 'Eliminado') return 'bg-red-100 text-red-800 border-red-200';
        return 'bg-blue-100 text-blue-800 border-blue-200';
    };
    
    return (
        <select 
            value={status} 
            onChange={(e) => onSelect(e.target.value)}
            className={`text-[10px] font-black uppercase px-2 py-1 rounded-full border-2 cursor-pointer focus:ring-1 focus:outline-none transition-all ${getColors(status)}`}
        >
            {options.map(opt => <option key={opt} value={opt} className="bg-white text-gray-800">{opt}</option>)}
        </select>
    );
};
